'use strict';
import {epics as modelEpics} from '../model/epics';
import {epics as navigationEpics} from '../navigation/epics';
import {epics as onAnimatedStateGoEpics} from './onAnimatedStateGo';
import {epics as onLocationChangeEpics} from './onLocationChange';
import {epics as onToggleMainMenuEpics} from './onToggleMainMenu';


export const epics = [
  ...modelEpics,
  ...navigationEpics,
  ...onAnimatedStateGoEpics,
  ...onLocationChangeEpics,
  ...onToggleMainMenuEpics,
];



// WEBPACK FOOTER //
// ./src/js/app/epics/index.js